// components/dialogs/DuplicateWarningDialog.tsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

interface DuplicateWarningDialogProps {
  open: boolean;
  confirmedNotDuplicate: boolean;
  onClose: () => void;
  onContinue: () => void;
  onConfirmedChange: (checked: boolean) => void;
}

export const DuplicateWarningDialog: React.FC<DuplicateWarningDialogProps> = ({
  open,
  confirmedNotDuplicate,
  onClose,
  onContinue,
  onConfirmedChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>⚠️ Possible Duplicate Found</DialogTitle>
      <DialogContent>
        A potential duplicate customer with a match score over 70% exists.
        <br />
        Please make sure this is not a duplicate entry.
        <FormControlLabel
          sx={{ mt: 1 }}
          control={
            <Checkbox
              checked={confirmedNotDuplicate}
              onChange={(e) => onConfirmedChange(e.target.checked)}
            />
          }
          label="I confirm this is not a duplicate customer."
        />
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          variant="text"
          onClick={onContinue}
          disabled={!confirmedNotDuplicate}
        >
          Continue Saving
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          color="warning"
        >
          Go Back
        </Button>
      </DialogActions>
    </Dialog>
  );
};